var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95645 2.17493C10.2064 2.17493 11.2193 3.18487 11.2193 4.43119C11.2193 5.67751 10.2064 6.68746 8.95645 6.68746C7.70648 6.68746 6.69357 5.67751 6.69357 4.43119C6.69357 3.18487 7.70648 2.17493 8.95645 2.17493ZM8.95645 11.8446C12.1568 11.8446 15.5296 13.4133 15.5296 14.1009V15.2827H2.38331V14.1009C2.38331 13.4133 5.75609 11.8446 8.95645 11.8446ZM8.95645 0.133545C6.57504 0.133545 4.6462 2.05674 4.6462 4.43119C4.6462 6.80564 6.57504 8.72884 8.95645 8.72884C11.3379 8.72884 13.2667 6.80564 13.2667 4.43119C13.2667 2.05674 11.3379 0.133545 8.95645 0.133545ZM8.95645 9.80325C6.07936 9.80325 0.335938 11.243 0.335938 14.1009V17.3241H17.577V14.1009C17.577 11.243 11.8336 9.80325 8.95645 9.80325Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonform);
export default __webpack_public_path__ + "static/media/personform.64880db7c1afe9a2691440dfdde9035c.svg";
export { ForwardRef as ReactComponent };